export default __webpack_public_path__ + "static/media/repeat.26ce2ab2.svg";